import request from '@/utils/request';
const baseURL = '/api/posclient/';

//------------訂單管理相關-----------
//取得訂單列表
export function listOrder() {
  return request({
    method: 'post',
    url: `${baseURL}listOrder`,
  });
}
//作廢訂單
export function invalidOrder(data) {
  return request({
    timeout: data.timeout || 25000,
    loading: data.timeout ? false : true,
    method: 'post',
    url: `${baseURL}invalidOrder`,
    data,
  });
}
//複製訂單
export function duplicateOrder(order_id) {
  return request({
    method: 'post',
    url: `${baseURL}duplicateOrder`,
    data: {
      order_id,
    },
  });
}
//沖銷訂單
export function writeOffOrder(order_id) {
  return request({
    method: 'post',
    url: `${baseURL}writeOffOrder`,
    data: {
      order_id,
    },
  });
}
//進階搜尋
export function searchOrder(data) {
  return request({
    method: 'post',
    url: `${baseURL}searchOrder`,
    data,
  });
}
//重印正本發票
export function reprintOriginalInvoice(data) {
  return request({
    method: 'post',
    url: `${baseURL}reprintOriginalInvoice`,
    data,
  });
}
//補印副本發票
export function reprintInvoice(data) {
  return request({
    method: 'post',
    url: `${baseURL}reprintInvoice`,
    data,
  });
}
